import { Component } from 'react';
import classnames from 'classnames';
import classBind from 'classnames/bind';

import styles from './styles.scss';

let cx = classBind.bind(styles);

export default class CheckBox extends Component {
  render() {
    const {
      fieldValue,
      toggleValue,
      input: { onChange, name, value },
    } = this.props;

    const checked = this.props.checked !== undefined ? this.props.checked : value === fieldValue;

    let className = cx({
      checkBox: true,
      block: this.props.block,
      inline: this.props.inline,
    });

    return (
      <div className={classnames(className)}>
        <input
          type="checkbox"
          name={name}
          value={value}
          onChange={() => (checked ? onChange(toggleValue) : onChange(fieldValue))}
          checked={checked}
        />
        <div className="checkboxInput">
          <div className="checkboxInputCheck" />
        </div>
        <div className="checkboxLabel">{this.props.children}</div>
      </div>
    );
  }
}
